import React from "react";
import ModelDataValueUpdateDetailsBase from "./updateModelDataValueBase";
import { ValueChange } from "./baseDetails";

export default function modelDataValueTimingRefUpdateDetails({ row }) {
    return (
        <ModelDataValueUpdateDetailsBase row={row}>
            <ValueChange oldValue={row.old_value_name} newValue={row.new_value_name} />
        </ModelDataValueUpdateDetailsBase>
    );
}
